import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

const H1 = ({ children, className }) =>
  <h1 className={classNames('H1', className)}>
    {children}
  </h1>;

H1.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

H1.defaultProps = {
  className: null,
};

export default H1;



// WEBPACK FOOTER //
// ./src/components/H1/index.js